import React from 'react';
import PropTypes from 'prop-types';

import { Scrollbars } from 'react-custom-scrollbars';

import { withStyles } from '@material-ui/core/styles';
import RootRef from '@material-ui/core/RootRef';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';

import { Fields } from 'redux-form';

import FiltersFields from 'components/fields/FiltersFields';

const styles = theme => ({
  expansionPanel: {
    overflow: 'hidden',
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10,
    '&:last-child': {
      borderBottomLeftRadius: 10,
      borderBottomRightRadius: 10,
    },
  },
  expansionPanelDetails: {
    flexWrap: 'wrap',
    padding: '8px 20px 8px 8px',
    backgroundColor: theme.palette.grey[100],
  },
});

const ClaimsFilterExpansionDetails = ({
  prefix, expanded, expansionDetailsRef, classes,
}) => (
  <ExpansionPanel
    className={classes.expansionPanel}
    elevation={0}
    expanded={expanded}
  >
    <RootRef
      rootRef={expansionDetailsRef}
    >
      <Scrollbars
        autoHeight
        autoHeightMin={0}
        autoHeightMax={300}
        thumbMinSize={30}
        universal
      >
        <ExpansionPanelDetails
          className={classes.expansionPanelDetails}
        >
          <Fields
            id="Claim_Filters"
            names={[
              'Filters.User',
              'Filters.Payer',
              'Filters.Order Status',
              'Filters.Claim Status',
              'Filters.Check Number',
              'Filters.Date of Creation',
              'Filters.Date of Service',
            ]}
            component={FiltersFields}
            prefix={prefix}
          />
        </ExpansionPanelDetails>
      </Scrollbars>
    </RootRef>
  </ExpansionPanel>
);

ClaimsFilterExpansionDetails.propTypes = {
  prefix: PropTypes.node,
  expanded: PropTypes.bool,
  expansionDetailsRef: PropTypes.func,
  classes: PropTypes.shape({
    expansionPanelDetails: PropTypes.string.isRequired,
  }).isRequired,
};

ClaimsFilterExpansionDetails.defaultProps = {
  expanded: false,
  prefix: null,
  expansionDetailsRef: () => {},
};

export default withStyles(styles)(ClaimsFilterExpansionDetails);



// WEBPACK FOOTER //
// ./src/components/reports/ClaimsFilter/ClaimsFilterExpansionDetails.js